module.exports = __webpack_public_path__ + "static/media/ad-nnlive-desktop.5c92a08f.png";